import { useProviderTableStore } from '../filters.store';

export const useFilters = () => {
  const { handleToggleFiltersCard, appliedFiltersCount, isFiltersCardOpen } =
    useProviderTableStore();

  return {
    handleToggleFiltersCard,
    isFiltersCardOpen,
    appliedFiltersCount,
  };
};
